/* eslint-disable @typescript-eslint/indent */
import React from 'react'
import ReactDOM from 'react-dom'
import { ThemeProvider } from 'styled-components'
import { CssBaseline } from '@kite-js/core'
import { DroneContextProvider, DroneContextBuilder } from '@drone-js/core'
import { theme as droneAgodaTheme } from '@drone-js/theme-agoda'
import agodaTheme from './common/themes/agoda'
import { RoutingStrategy } from './routes/types'
import { createRouter } from './routes/router-factory'
import { RouterProvider } from 'react-router-dom'
import measureLanding from './common/performance'

interface IBoostrap {
    mountPoint: HTMLElement
    initialPathname?: string
    routingStrategy?: RoutingStrategy
}

const mount = (props: IBoostrap) => {
    const router = createRouter({ strategy: props.routingStrategy, initialPathname: props.initialPathname })
    const container = props.mountPoint

    measureLanding(window.location.href)

    const context = new DroneContextBuilder()
        .withTheme(droneAgodaTheme)
        .build()

    ReactDOM.render(
        <React.StrictMode>
            <DroneContextProvider context={context}>
                <ThemeProvider theme={agodaTheme}>
                    <CssBaseline />
                    <RouterProvider router={router} />
                </ThemeProvider>
            </DroneContextProvider>
        </React.StrictMode>,
        container
    )
}

export { mount }
